import React, { useContext, useState, useEffect } from 'react'
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Home from './Frontend/Pages/Home';
import Layout from './Frontend/Common/Layout';
import Inventory from './Frontend/Pages/Inventory';
import Vdp from './Frontend/Pages/Vdp';
import Service from './Frontend/Pages/Service';
import Detailing from './Frontend/Pages/Detailing';
import Finance from './Frontend/Pages/Finance';
import WeBuyExotics from './Frontend/Pages/WeBuyExotics';
import WeBuyExoticsSecond from './Frontend/Pages/WeBuyExoticsSecond';
import FerrariService from './Frontend/Components/Service/FerrariService';
import LamborghiniRepair from './Frontend/Components/Service/LamborghiniRepair';
import PorscheRepair from './Frontend/Components/Service/PorscheRepair';
import MaseratiRepair from './Frontend/Components/Service/MaseratiRepair';
import MclarenRepair from './Frontend/Components/Service/MclarenRepair';
import ClassicCarRepair from './Frontend/Components/Service/ClassicCarRepair';
import AudiR8Repair from './Frontend/Components/Service/AudiR8Repair';
import KoenigseggRepair from './Frontend/Components/Service/KoenigseggRepair';
import ConsignYourCar from './Frontend/Pages/ConsignYourCar';
import CarFinder from './Frontend/Pages/CarFinder';
import OurTeam from './Frontend/Components/OurTeam/OurTeam';
import AutomotiveJobs from './Frontend/Pages/AutomotiveJobs';
import CustomerReviews from './Frontend/Pages/CustomerReviews';
import SellMyVehicle from './Frontend/Pages/SellMyVehicle';
import FinanceTampa from './Frontend/Components/Finance/FinanceTampa';
import FinanceSanClemente from './Frontend/Components/Finance/FinanceSanClemente';
import About from './Frontend/Pages/About';
import Sitemap from './Frontend/Pages/Sitemap';
import Privacy from './Frontend/Pages/Privacy';
import Login from './Frontend/Components/Admin/Login';
import AdminLayout from './Frontend/Components/Admin/AdminLayout';
import { UserContext } from './Frontend/Context/UserContext';
import FeaturedVehicles from './Frontend/Components/Admin/FeaturedVehicles';
import ServiceAstonMartinRepair from './Frontend/Components/Service/ServiceAstonMartinRepair';
import ManageTeam from './Frontend/Components/Admin/ManageTeam';
import EditContent from './Admin/EditContent';
import SellMyVehicleTampa from './Frontend/Pages/SellMyVehicleTampa';
import SellMyVehicleSanClemente from './Frontend/Pages/SellMyVehicleSanClemente';

const PrivateRoute = ({ user }) => {
  return user && user.username && user.username !== "publicuser" ? (
      <Outlet />
  ) : (
      <Navigate to="/login" replace />
  );
};

const PublicRoute = ({ user, children }) => {
  return user && user.username && user.username !== "publicuser" ? (
      <Navigate to="/admin/dashboard" replace />
  ) : (
      children
  );
};

const AppRoutes = () => {
  const {user, loggedInCheck} = useContext(UserContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      const checkLoginStatus = async () => {
          if (window.location.pathname.startsWith("/admin") || window.location.pathname === "/login") {
              await loggedInCheck();
          }
          setLoading(false);
      };
      checkLoginStatus();
  }, []);
  if (loading) {
      return <div>Loading...</div>;
  }

  return (
    <Routes>
      {/* <Route path="/login" element={<Login />} /> */}
      <Route
        path="/*"
        element={
          <Layout>
            <Routes>
              <Route index element={<Home />} />
              <Route path='/cars-for-sale-florida-california' element={<Inventory />} />
              <Route path='/cars-for-sale-florida-california/all' element={<Inventory typeFilter={"ALL"}/>} />
              <Route path='/cars-for-sale-florida-california/tampa' element={<Inventory typeFilter={"Tampa, FL"}/>} />
              <Route path='/cars-for-sale-florida-california/san-clemente' element={<Inventory typeFilter={"San Clemente, CA"}/>} />
              <Route path='/vehicle-details/*' element={<Vdp />} />
              <Route path='/car-service-in-tampa-fl' element={<Service />} />
              <Route path='/aston-martin-repair' element={<ServiceAstonMartinRepair />} />
              <Route path='/detailing' element={<Detailing />} />
              <Route path='/finance' element={<Finance />} />
              <Route path='/we-buy-exotics' element={<WeBuyExotics />} />
              <Route path='/we-buy-exotics-2' element={<WeBuyExoticsSecond />} />
              <Route path='/about-european-exotic-center' element={<About />} />
              <Route path='/ferrari-repair' element={<FerrariService />} />
              <Route path='/lamborghini-repair' element={<LamborghiniRepair />} />
              <Route path='/porsche-repair' element={<PorscheRepair />} />
              <Route path='/maserati-repair' element={<MaseratiRepair />} />
              <Route path='/mclaren-repair' element={<MclarenRepair />} />
              <Route path='/classic-car-repair' element={<ClassicCarRepair />} />
              <Route path='/audi-r8-repair' element={<AudiR8Repair />} />
              <Route path='/koenigsegg-repair' element={<KoenigseggRepair />} />
              <Route path='/consign-your-car' element={<ConsignYourCar />} />
              <Route path='/car-finder' element={<CarFinder />} />
              <Route path='/european-exotic-center-staff' element={<OurTeam />} />
              <Route path='/automotive-jobs' element={<AutomotiveJobs />} />
              <Route path='/european-exotic-center-customer-reviews' element={<CustomerReviews />} />
              <Route path='/sell-my-vehicle' element={<SellMyVehicle />} />
              <Route path='/sell-my-vehicle-tampa' element={<SellMyVehicleTampa />} />
              <Route path='/sell-my-vehicle-san-clemente' element={<SellMyVehicleSanClemente />} />
              <Route path='/finance-tampa' element={<FinanceTampa />} />
              <Route path='/finance-san-clemente' element={<FinanceSanClemente />} />
              <Route path='/sitemap' element={<Sitemap />} />
              <Route path='/privacy' element={<Privacy />} />
              {/*<Route path="*" element={<Navigate to="/cars-for-sale-florida-california" replace />} />*/}
              <Route path="*" element={<Home />} />
            </Routes>
          </Layout>
        }
      />
        <Route
            path="/login"
            element={
                <PublicRoute user={user}>
                    <Login />
                </PublicRoute>
            }
        />
        {/* Private Routes */}
        {/* {checkedLogin &&  */}
        {/* <Route path="/admin/featured-vehicles" element={<FeaturedVehicles />} /> */}
        <Route element={<PrivateRoute user={user} />}>
            <Route element={<AdminLayout />}>
                <Route path="/admin/featured-vehicles" element={<FeaturedVehicles />} />
                
                {/* Replace URL's */}
                <Route path="/admin/*" element={<Navigate to="/admin/featured-vehicles" replace />} />
                <Route path="/admin" element={<Navigate to="/admin/featured-vehicles" replace />} />
                <Route path="/admin/manage-team" element={<ManageTeam />} />
                <Route path="/admin/edit-content" element={<EditContent />} />
            </Route>
        </Route>
        {/* // } */}
        {/* {!checkedLogin && <>
            <Route path="/admin/manage-vehicles" element={<Login />} />
        </>} */}
        {/*<Route path="*" element={<Navigate to="/inventory" replace />} />*/}
    </Routes>
  )
}

export default AppRoutes